module.exports = __webpack_public_path__ + "static/media/image_ok.e474e152.svg";